import { Box, Typography } from '@mui/material'
import { styled, withStyles } from '@mui/styles'

export const InfoPopupContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 12,
  paddingRight: 16,
  paddingBottom: 10,
  paddingLeft: 16,
  gap: theme.spacing(0.5),
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius
}))

export const InfoPopupStatus = styled(Box)(({ theme, sitecolor }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  color: theme.palette.common.white,
  backgroundColor: sitecolor || theme.palette.grey[100],
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
}))

export const PopupTitle = withStyles(() => ({
  root: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.333,
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const PopupStatusLabel = withStyles(() => ({
  root: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.333,
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const SupervisionLabel = withStyles((theme) => ({
  root: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.333,
    fontStyle: 'italic',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}))(Typography)

export const AccesspointComponent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0.5),
  gap: theme.spacing(1)
}))

export const LabelContainer = styled('svg')({
  position: 'absolute',
  zIndex: 1
})

export const MarkerContainer = styled('svg')({
  position: 'absolute',
  zIndex: 2,
  cursor: 'pointer'
})